"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.33342 14.7153V16.6665C8.33342 17.587 9.07961 18.3332 10.0001 18.3332C10.9206 18.3332 11.6667 17.587 11.6667 16.6665V14.7153M10.0001 1.6665V2.49984M2.50008 9.99984H1.66675M4.58341 4.58317L4.08333 4.08309M15.4167 4.58317L15.917 4.08309M18.3334 9.99984H17.5001M15.0001 9.99984C15.0001 12.7613 12.7615 14.9998 10.0001 14.9998C7.23866 14.9998 5.00008 12.7613 5.00008 9.99984C5.00008 7.23841 7.23866 4.99984 10.0001 4.99984C12.7615 4.99984 15.0001 7.23841 15.0001 9.99984Z",
    stroke: fill,
    strokeWidth: "1.67331",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;